export default "__VITE_ASSET__522d78a9__"